<template>
  <div class="wrap">
    <div class="join">
      <div class="container">
        <div class="join_wrap">
          <JoinStepOne v-if="currentStep === 1" @nextStep="goToNextStep" />
          <JoinStepCertification
            v-if="currentStep === 2"
            @nextStep="goToNextStep"
          />
          <JoinStepTwo v-if="currentStep === 3" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import JoinStepOne from '../components/JoinStepOne.vue'
import JoinStepTwo from '../components/JoinStepTwo.vue'
import JoinStepCertification from '../components/JoinStepCertification.vue'

export default {
  name: 'JoinStepView',
  components: {
    JoinStepOne,
    JoinStepTwo,
    JoinStepCertification,
  },
  setup() {
    const currentStep = ref(1)
    const goToNextStep = () => {
      if (currentStep.value < 3) {
        currentStep.value += 1
      }
    }

    return {
      currentStep,
      goToNextStep,
    }
  },
}
</script>

<style></style>
